export default __webpack_public_path__ + "static/media/squares-2-16.e49a18a8.svg";